export const styles = () => ({
  duplicates: {
    paddingTop: 5,
    paddingBottom: 5,
  },
});
